import { render } from "./DeclinedPage.vue?vue&type=template&id=ffb3b806&scoped=true"
const script = {}

import "./DeclinedPage.vue?vue&type=style&index=0&id=ffb3b806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb3b806"]])

export default __exports__